import Sedes from "./sedes";

export default Sedes;
